import { connect } from 'react-redux';
import PaymentPopupComponent from './../../components/PaymentPopup';
import { removePaymentRequest, setPaymentResponse } from '../../actions';

export const mapStateToProps = ({ paymentRequest }) => ({
  paymentRequest,
});

const PaymentPopupContainer = connect(mapStateToProps, { removePaymentRequest, setPaymentResponse })(PaymentPopupComponent);

export default PaymentPopupContainer;



// WEBPACK FOOTER //
// ./src/app/containers/PaymentPopup/index.js